import Pusher from "pusher-js";


const pusher = new Pusher(`${process.env.REACT_APP_PUSHER_KEY}`, {
  cluster: "eu",
  encrypted: true,
});

export const getLiveData = async (
  appState,appDispatch,
  invoiceId,
  orderStatus,
  setOrderStatus,
) => {
  let channel = pusher.subscribe(`App.Models.Invoice.${invoiceId}`);
  if (invoiceId != "") {

    channel.bind("service-status-changed", async (data) => {
      setOrderStatus(data?.data?.new_status)   
      // if(data?.order?.status == "Completed"){
      //   setOrderStatus({...orderStatus,notCompleted:false,orderData:{}})
      // }else{
      //   setOrderStatus({...orderStatus,notCompleted:true,orderData:data?.order})
      // }
    });

    channel.bind("order-updated", async (data) => {
      if(data?.order?.status == "Completed"){
        setOrderStatus({orderStatus: orderStatus, notCompleted:false, orderData:{}})
      }else{
        setOrderStatus({orederStatus: orderStatus, notCompleted:true, orderData:data?.order})
      }
    });
 
 

    channel.bind("invoice-cancel", function (data) {
      let id = data?.data?.id;
      // appDispatch(cleanRest());
      const winUrl = window.open(
        `${process.env.REACT_APP_PAY_URL}/invoice/in/${id}`,
        "_self"
      );
      winUrl.focus();
    });


    channel.bind("invoice-updated", function (data) {
    //   let id = data?.data?.id;

    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }
};
